import PropTypes from 'prop-types';


OBSDimensions.propTypes = {
  obsDimensions: PropTypes.oneOfType([
    PropTypes.shape({
      width: PropTypes.string,
      height: PropTypes.string,
    }),
    PropTypes.arrayOf(
      PropTypes.shape({
        width: PropTypes.string,
        height: PropTypes.string,
      })
    ),
  ]),
  orientation: PropTypes.string,
};
export default function OBSDimensions({obsDimensions, orientation}) {
  const dimensions = { width: '0px', height: '0px' };
  let showDimensions, dimensionBlock;

  if (Array.isArray(obsDimensions)) {
    const [vertical, horizontal] = obsDimensions;

    // Then check if we are using horizontal/vertical orientation
    if (orientation === 'vertical') {
      dimensions.width = vertical.width;
      dimensions.height = vertical.height;
    } else {
      dimensions.width = horizontal.width;
      dimensions.height = horizontal.height;
    }

    showDimensions = true;
  } else if (obsDimensions) {
    dimensions.width = obsDimensions.width;
    dimensions.height = obsDimensions.height;
    showDimensions = true;
  } else {
    showDimensions = false;
  }

  if (showDimensions)
    dimensionBlock = (
      <li>
        <span className="select-none">3. Set width: </span><strong>{dimensions.width}</strong><span className="select-none"> height:{' '}</span>
        <strong>{dimensions.height}</strong>
      </li>
    );
  else dimensionBlock = <li className="select-none">3. Set width and height to your preferred size</li>;

  return dimensionBlock;
}